var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlipay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0baef4",
    width: 42,
    height: 42,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "alipay"), /*#__PURE__*/React.createElement("path", {
    d: "M8.295 17.292c-1.107 0.098-2.107 0.489-2.943 1.094l0.017-0.012c-2.306 2.004-0.926 5.67 3.74 5.67 3.164-0.279 5.879-1.984 7.527-4.46l0.023-0.037c-2.313-1.417-5.114-2.256-8.111-2.256-0.089 0-0.179 0.001-0.268 0.002l0.013-0zM21.094 18.164c1.058-1.815 1.917-3.916 2.468-6.139l0.035-0.166h-5.912v-2.123h7.242v-1.185h-7.242v-3.54h-2.955c-0.005-0-0.011-0-0.017-0-0.277 0-0.502 0.225-0.502 0.502 0 0.003 0 0.006 0 0.009v-0 3.030h-7.324v1.185h7.324v2.123h-6.047v1.185h11.729c-0.463 1.576-1.037 2.941-1.744 4.224l0.054-0.107c-3.805-1.252-7.867-2.267-10.418-1.642-1.318 0.265-2.451 0.93-3.296 1.861l-0.004 0.005c-2.833 3.438-0.801 8.659 5.182 8.659 3.944-0.218 7.384-2.204 9.564-5.173l0.025-0.035c3.94 1.889 11.74 5.132 11.74 5.132v0.196c-0.003 2.646-2.148 4.79-4.795 4.79-0.003 0-0.005 0-0.008 0h-20.384c-0.002 0-0.005 0-0.008 0-2.647 0-4.794-2.144-4.797-4.791v-20.324c0.003-2.647 2.149-4.791 4.796-4.791 0.003 0 0.006 0 0.009 0h20.384c0.002 0 0.005 0 0.007 0 2.647 0 4.793 2.145 4.795 4.791v15.507c-2.037-0.403-3.812-0.928-5.516-1.595l0.218 0.075c-1.2-0.401-2.81-1.014-4.604-1.661z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlipay);
export default __webpack_public_path__ + "static/media/Alipay.8c28887fc37623fd3df26e407ce2adfe.svg";
export { ForwardRef as ReactComponent };